import { useState } from "react";
import { trpc } from "../../lib/trpc";
import { Loader2, User } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";

export function OrgAdminResidentsPage() {
  const [searchTerm] = useState("");
  
  const { data: residents, isLoading } = trpc.admin.listResidents.useQuery({
    search: searchTerm || undefined
  });

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Residents</h1>
          <p className="text-muted-foreground">
            View all residents in your organization's buildings.
          </p>
        </div>
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Username</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Building</TableHead>
              <TableHead>Unit</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
           <TableBody>
             {residents?.map((resident: any) => {
                const primaryUnit = resident.unit_owners?.[0];
                return (
                 <TableRow key={resident.id}>
                   <TableCell className="font-medium">
                     <div className="flex items-center gap-2">
                        <User className="h-4 w-4 text-muted-foreground" />
                        {resident.name}
                     </div>
                   </TableCell>
                   <TableCell>{resident.username}</TableCell>
                   <TableCell>{resident.phone}</TableCell>
                   <TableCell>
                     {primaryUnit?.buildings?.name} ({primaryUnit?.buildings?.code})
                   </TableCell>
                   <TableCell>{primaryUnit?.units?.unit_no}</TableCell>
                  <TableCell>
                    <Badge variant={resident.status === "active" ? "default" : "secondary"}>
                      {resident.status === "pending_first_login" ? "Pending" : resident.status}
                    </Badge>
                  </TableCell>
                </TableRow>
               );
            })}
            {(!residents || residents.length === 0) && (
              <TableRow>
                <TableCell colSpan={6} className="text-center h-24">
                  No residents found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
